import type { Tour, TourSource } from '@/types/tour'

export const isDownloadableTourSourceFilename = (filename?: string | null): boolean => {
  const value = filename?.trim()
  return !!value && /\.(gpx|fit)(\.gz)?$/i.test(value)
}

export const getRootSourceTourClientId = (
  tour: Pick<Tour, 'clientId' | 'sourceTour' | 'sourceTourClientId'>,
): string => tour.sourceTour?.clientId ?? tour.sourceTourClientId ?? tour.clientId

export const getRootSourceTour = (tour: Tour): TourSource =>
  tour.sourceTour ?? {
    clientId: tour.clientId,
    name: tour.name,
    workspaces: tour.workspaces ?? [],
  }
